export default __webpack_public_path__ + "static/media/logocfdi.af7ffa67.png";